<template>
  <div class="row">
    <img
      src="https://cdncampaigns.cathaylife.com.tw/OAWeb/html/OA/C8/img/logo/Cathay-life-rgb-db.svg"
      alt="國泰人壽"
    >
  </div>
</template>
<script>
export default {
  name: "index"
};
</script>